<template>
    <div class="content">
        <router-view></router-view>
        <tab-bar :routers="tabbar"></tab-bar>
    </div>
</template>

<script>
    import TabBar from "../components/TabBar";
    export default {
        name: "Index",
        components: {TabBar},
        data() {
            return {
                tabbar:[
               
                ]
            }
        },


    }
</script>

<style scoped>
    .content {
        background-color: #eee;
    }
</style>